/**
 * Display a Year-Make-Model-Trim value.
 * @param {String} input
 */
export default ymmt => ymmt && [ymmt.year, ymmt.make, ymmt.model, ymmt.trim].join(' ')
